import _ from 'lodash'
import { withinDays } from './date'

export const getTopKPrioritizedBadges = (asset, k = 2) => {
  const priorityArray = [
    {
      name: 'Broker Commission Available',
      iconName: 'handshake',
      iconStyle: 'light',
      priority:
        asset && _.get(asset, 'is_broker_commission_available', false) === true
          ? 1
          : 0,
    },
    {
      name: 'Financing Available',
      iconName: 'hand-holding-usd',
      iconStyle: 'light',
      priority: asset && asset.financing_available ? 2 : 0,
    },
    {
      name: "No Buyer's Premium",
      iconName: 'ban',
      iconStyle: 'light',
      priority: asset && !asset.buyer_premium_avail ? 3 : 0,
    },
    {
      name: 'Interior Access',
      iconName: 'door-open',
      iconStyle: 'light',
      priority: asset && asset.interior_access ? 4 : 0,
    },
    {
      name: 'Vacant',
      iconName: 'sign',
      iconStyle: 'light',
      priority: asset && asset.occupancy_status === 'Vacant' ? 5 : 0,
    },
    {
      name: 'Newly Listed',
      iconName: 'certificate',
      iconStyle: 'light',
      priority: asset && withinDays(asset.activation_date, 3) ? 6 : 0,
    },
  ]
  return _.filter(
    _.slice(_.orderBy(priorityArray, ['priority'], ['desc']), 0, k),
    badge => badge.priority > 0
  )
}
